import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {
  data: any[];
  matdata: any;
  invokeFirstComponentFunction = new EventEmitter();
  invokeMaturityFunction =  new EventEmitter();
  subsVar1: Subscription;
  subsVar: Subscription;
  constructor() { }
  emitda(ap, ai, pi, ri, cf, type) {
    this.data = [ap, ai, pi, ri, cf, type];
    this.invokeFirstComponentFunction.emit();
  }
  get() {
      return(this.data);
  }
  emitdata(data) {
    console.log('came to maruity sevice');
    this.matdata = data;
    this.invokeMaturityFunction.emit();

  }
  getda() {
    return(this.matdata);
}
}
